import React, { useEffect, useState } from 'react'
import { ReactComponent as VisaIcon } from '../../../../icons/visa.svg'
import { BankOutlined } from '@ant-design/icons';
import { Card ,Button,Collapse, Modal} from 'antd';
import { EditOutlined,DeleteOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const ShowCardFlow = (props) => {
    const [cardInformation, setCardInformation] = useState([]);
    const [modalText, setModalText] = useState("");
    const [loader,setLoader] = useState(false)
    const [selectedCardId, setSelectedCardId] = useState(null);
    let cardNumber = {};

    useEffect(() => {
        setCardInformation(props.userInformation)
        cardInformation.map ( (info,index) => {
            cardNumber[index] = info.id
        })
    })

    const EditCreditCard = (id) => {        
        setSelectedCardId(id);
        setModalText("Are you sure you want to delete this payment method and enter a new one?")
        props.setOpenModal(true)
    }

    const DeleteCreditCard = (id) => {
        setSelectedCardId(id);
        setModalText("Are you sure you want to delete this payment method?")
        props.setOpenModal(true)
    }

    const handleOk = () => {
        setLoader(true)
        props.deleteUserPaymentType(selectedCardId)
    }

    const handleCancel = () => {
        props.setOpenModal(false)
    }

    return (
        <div>
          <h2 className="manrope f-16 black-14" style={{marginBottom: 28}}>Your Payment Information is saved in our system.</h2>
            {cardInformation.map ( (info,index)  => (
                <Card className='grey-background' style={{marginTop:"5%",width:"600px"}} >  
                    <Panel showArrow={false} collapsible={false} header={
                        <div style={{display:"flex", padding:"2.5%"}}>
                            {info.type === 'us_bank_account' ? (
                                <BankOutlined style={{fontSize: '40px', marginTop:"1%", marginLeft:"2%", color: '#1890ff'}}/>
                            ) : (
                                <VisaIcon style={{height:"45%",width:"10%",marginTop:"1%", marginLeft:"2%"}}/>
                            )}
                            
                            <div style={{ marginLeft:"3%",marginRight:"6%"}}>
                                {info.type === 'us_bank_account' ? (
                                    <span style={{display:"flex",flexDirection:"column", fontWeight:"bold"}}>
                                        {info.us_bank_account.bank_name + " **** " + info.us_bank_account.last4}
                                    </span>
                                ) : (
                                    <>
                                        <span style={{display:"flex",flexDirection:"column", fontWeight:"bold"}}>
                                            {info.card.brand + "  **** **** **** "  + info.card.last4}
                                        </span>
                                        <span>
                                            Expires {" " + String(info.card.exp_month) + "/" + String(info.card.exp_year) }
                                        </span>
                                    </>
                                )}
                            </div>
                            
                            <div style={{position:"absolute", right:"3%"}}>
                                <Button id={index} ghost  type="primary" shape="square" icon={<EditOutlined />} size={"medium"} style={{position:"relative", marginRight:"10px"}} onClick={() => EditCreditCard(info.id)}>Edit</Button>
                                <Button id={index} ghost danger type="primary" shape="square" icon={<DeleteOutlined />} size={"medium"} onClick={() => DeleteCreditCard(info.id)}>Delete</Button>
                            </div>
                        </div>
                    }>
                    </Panel>
                </Card>
                
            ))}
        
            <Modal title="Edit / Delete Payment Method" visible={props.openModal}
            footer={[<Button style={{borderRadius:"5px"}} key="back" onClick={handleCancel}>
                Cancel
            </Button>,
            <Button style={{borderRadius:"5px"}} key="submit" type="primary" loading={loader} onClick={handleOk}>
                Delete
            </Button>
            ]}  onCancel={handleCancel}>
           
                    <h3 className='manrope f-14'>{modalText}</h3>
            </Modal>
        </div>
      );
};

export default ShowCardFlow;
